import { create } from 'zustand';
import { createSelectors } from '../../../utils/store';

export type AssistantAction = {
  type: 'navigate';
  label: string;
  path: string;
};

export type ChatMessage = {
  role: string;
  content: string;
  actions?: AssistantAction[];
  /**
   * Set on the `Error: …` line this page appends when a turn fails
   * (DASHBOARD-3X). Locally generated, so it must not be replayed to the API
   * or to the model on the next turn — `historyForWire` drops it.
   */
  isLocalError?: boolean;
};

type State = {
  messages: ChatMessage[];
  conversationId: string | null;
  addMessage: (message: ChatMessage) => void;
  setMessages: (messages: ChatMessage[]) => void;
  setConversationId: (id: string | null) => void;
  clearMessages: () => void;
};

const store = create<State>((set) => ({
  messages: [],
  conversationId: null,
  addMessage: (message) =>
    set((state) => ({ messages: [...state.messages, message] })),
  setMessages: (messages) => set({ messages }),
  setConversationId: (conversationId) => set({ conversationId }),
  clearMessages: () => set({ messages: [], conversationId: null }),
}));

export const useChatMessages = createSelectors(store);
